import "../../../constants/index.js";
import { FieldType } from "../../../types/api.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
import { ReferralCommissionSettingsSpec, ReferralOverallSpec, ReferralTxModelSpec } from "../../../types/models/referral.specs.js";
function referralEndpoints(builder) {
  return {
    getReferralInfo: builder.query({
      providesTags: ["referral"],
      query: () => ({
        url: `/member/referral/info`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(ReferralCommissionSettingsSpec)
    }),
    getReferralAvailableClaim: builder.query({
      query: () => ({
        url: `/member/referral/claim/available`,
        method: "GET"
      }),
      transformResponse: transformWithSpec({
        availableAmount: FieldType.BigNumber
      })
    }),
    claimReferral: builder.mutation({
      invalidatesTags: ["referral", "referral-stats", "referral-tx"],
      query: (body) => ({
        url: `/member/referral/claim`,
        method: "POST",
        body
      })
    }),
    getReferralOverall: builder.query({
      providesTags: ["referral-stats"],
      query: () => ({
        url: `/member/referral/overall`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(ReferralOverallSpec)
    }),
    getReferralTxHistory: builder.query({
      providesTags: ["referral-tx"],
      query: ({ query }) => ({
        url: `/member/referral/tx/list${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(ReferralTxModelSpec)
    }),
    getReferralFriendHistory: builder.query({
      providesTags: ["referral-friend"],
      query: ({ query }) => ({
        url: `/member/referral/friend/list${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(ReferralTxModelSpec)
    })
  };
}
export {
  referralEndpoints as default
};
